import { Controller } from "@hotwired/stimulus"

// Shows the notification section only when upgrading to a more expensive rate.
export default class extends Controller {
  static targets = ["rateSelect", "notificationSection"]
  static values = { currentPrice: Number }

  connect() {
    this.updateNotificationVisibility()
  }

  rateChanged() {
    this.updateNotificationVisibility()
  }

  updateNotificationVisibility() {
    const selected = this.rateSelectTarget.selectedOptions[0]
    const newPrice = parseFloat(selected?.dataset?.price || 0)
    if (newPrice > this.currentPriceValue) {
      this.notificationSectionTarget.classList.remove("d-none")
    } else {
      this.notificationSectionTarget.classList.add("d-none")
    }
  }
}
